import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Helmet from 'react-helmet'

import CategoryGroup from './CategoryGroup'
import { ProductCategoryAction } from 'App/MainMenu'
import { setMetadata } from 'Shared/HeadMetadata/ducks'

class ProductCategory extends Component {
  constructor (props) {
    super()
  }

  componentDidMount () {
    if (
      !this.props.productCategories.items.length &&
      !this.props.productCategories.isLoading
    ) {
      this.props.ProductCategoryAction()
    }

    this.props.setMeta('Veja todas as categorias de produtos')
  }

  render () {
    return (
      <Fragment>
        <Helmet>
          <title>{`Todas as categorias - ${process.env.REACT_APP_TITLE || ''}`}</title>
        </Helmet>
        <div className={`container-all-categories container-all-with-context container-fluid ${this.props.onlyCash ? 'cat-context-cash' : 'cat-context-points'}`} data-context={this.props.onlyCash ? 'cash' : 'points'}>
          <div className='container'>
            <div className='row'>
              <div className='col-12 py-3'>
                <div className='row'>
                  <div className='col-12 border-color-ui-3 bg-white border radius'>
                    <div className='row px-3 py-2 border-bottom border-color-ui-3 '>
                      <div className='col-12 py-1'>
                        <h3 className='txt-initial color-brand-1 mr-auto'>
                          Veja todas as categorias de produtos
                        </h3>
                      </div>
                    </div>
                    <div className='col-12 pt-3 px-3'>
                      <div className='row'>
                        {this.props.productCategories.items.map((item, index) => (
                          <CategoryGroup key={index} {...item} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

ProductCategory.propTypes = {
  productCategories: PropTypes.object.isRequired,
  ProductCategoryAction: PropTypes.func.isRequired,
  setMeta: PropTypes.func,
  onlyCash: PropTypes.bool
}

const mapStateToProps = ({ productCategories, onlyCash }) => ({
  productCategories,
  onlyCash
})

const mapDispatchToProps = dispatch => ({
  ProductCategoryAction: () => dispatch(ProductCategoryAction()),
  setMeta: (title, description, keywords) =>
    dispatch(setMetadata(title, description, keywords))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductCategory)



// WEBPACK FOOTER //
// ./src/features/ProductCategory/ProductCategory.js